import type { MaybeRefOrGetter } from 'vue'

// overlays stack on top of each other — the menu and the search open over any
// page, a person opens over the people list, and the media lightbox opens over
// that again — so escape must only ever close the topmost one.
//
// the stack is client only: layers are (un)registered from a watcher that never
// runs while rendering on the server.
const layers: symbol[] = []

export const useEscapeLayer = (isOpen: MaybeRefOrGetter<boolean>, onEscape: () => void) => {
  if (import.meta.server) return

  const layer = Symbol('escape-layer')

  const leave = () => {
    const index = layers.indexOf(layer)
    if (index > -1) layers.splice(index, 1)
  }

  // whichever overlay opened last sits on top
  watch(() => toValue(isOpen), (open) => {
    leave()
    if (open) layers.push(layer)
  }, { immediate: true })

  onScopeDispose(leave)

  onKeyStroke('Escape', (event) => {
    if (layers.at(-1) !== layer) return
    event.preventDefault()
    onEscape()
  })
}
